import * as analytics from 'analytics';
import AudioPlayerStation from '../players/AudioPlayerStation';
import AudioPlayerOnDemand from '../players/AudioPlayerOnDemand';
import VideoJWPlayer from '../players/VideoJWPlayer';
import ChromeSender from '../players/ChromeSender';

import { playerVolumeActions } from './actions-const';

// Add new players here
const players = [AudioPlayerStation, AudioPlayerOnDemand, VideoJWPlayer];

export function setVolumeLevel(volumeLevel, trackAnalytics = true) {
  const muted = volumeLevel === 0;

  players.forEach((player) => {
    player.setVolumeLevel(volumeLevel);
    player.setMuted(muted);
  });
  ChromeSender.setVolumeLevel(volumeLevel);
  ChromeSender.setMuted(muted);

  if (trackAnalytics) {
    analytics.trackVolume(volumeLevel, 'TITLE');
  }
  return { type: playerVolumeActions.SET_VOLUME_LEVEL, volumeLevel };
}

export function setMuted(shouldBeMuted, trackAnalytics = true) {
  return async (dispatch, getState) => {
    const {
      player: { isMuted, volumeLevel: currentVolumeLevel },
    } = getState();

    players.forEach((player) => player.setMuted(shouldBeMuted));
    ChromeSender.setMuted(shouldBeMuted);

    dispatch({ type: playerVolumeActions.SET_MUTED, muted: shouldBeMuted });
    if (shouldBeMuted || shouldBeMuted === isMuted) {
      if (trackAnalytics) {
        analytics.trackVolume(0);
      }
      return;
    }
    const targetVolumeLevel = currentVolumeLevel === 0 ? 1 : currentVolumeLevel;
    dispatch(setVolumeLevel(targetVolumeLevel, trackAnalytics));
  };
}

export function toggleMute() {
  return async (dispatch, getState) => {
    const {
      player: { isMuted },
    } = getState();
    const nextMutedState = !isMuted;
    dispatch(setMuted(nextMutedState));
  };
}
